
import { computed, defineComponent, PropType, reactive, toRaw } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// types
import { SenderSpark } from '@/new-services/types/orders'

// realisations
import ordersAPI from '@/new-services/orders.service'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        'the-button': TheButton,
        cheap: Cheap,
    },
    props: {
        item: {
            type: Object as PropType<SenderSpark>,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'update', 'deleted'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_deleting: false,
        })

        //

        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        const emitDelete = async () => {
            const answer = confirm(
                `Вы действительно хотите удалить отправителя ${props.item.fullName}?`
            )

            if (!answer) return

            try {
                state.is_deleting = true

                await ordersAPI.deleteSenderSpark(props.item.id)
                notifications.notify({
                    title: `Отправитель ${props.item.fullName} удалён`,
                    type: 'success',
                })

                emit('deleted')
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: `Ошибка при удалении отправителя ${props.item.fullName}`,
                })
            } finally {
                state.is_deleting = false
            }
        }

        const emitSubmit = () => {
            if (!isSenderHaveCoordinates.value) {
                notifications.notify({
                    title: 'Не указан адрес',
                    description: 'Пожалуйста, укажите адрес на карте',
                    type: 'danger',
                })

                emit('update', toRaw(props.item))
                return
            }

            emit('submit', toRaw(props.item))
        }

        //

        const isSenderHaveCoordinates = computed(() => {
            if (Boolean(props.item.latitude) && Boolean(props.item.longitude)) {
                return true
            }

            return false
        })

        //

        return {
            state,
            //
            emitSubmit,
            emitUpdate,
            emitDelete,
            //
            isSenderHaveCoordinates,
        }
    },
})
